module.exports = __webpack_public_path__ + "img/Bongo_UI-UX 1.09721ba9.png";